var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('a',{staticClass:"header__logo",class:{ partner: _vm.partner },attrs:{"href":"https://www.ciclic.com.br/seguro-viagem/"}}),_c('b',{staticClass:"header__label"},[_vm._v("Viagem")])])
}
var staticRenderFns = []

export { render, staticRenderFns }